import { Link } from "react-router-dom";
import logoLockupColor from "@/assets/logo-lockup-color.svg";
import logoLockupOnDark from "@/assets/logo-lockup-on-dark.svg";
import logoIcon from "@/assets/logo-icon.svg";

interface LogoProps {
  className?: string;
  iconOnly?: boolean;
  size?: "sm" | "base" | "md" | "lg";
  variant?: "color" | "on-dark";
  onClick?: () => void;
}

export function Logo({ className = "", iconOnly = false, size = "md", variant = "color", onClick }: LogoProps) {
  const lockupClass = size === "sm" ? "h-7 w-auto" : size === "lg" ? "h-14 w-auto" : size === "md" ? "h-10 w-auto" : "h-8 w-auto";
  const iconClass = size === "sm" ? "h-6 w-auto" : size === "lg" ? "h-12 w-auto" : size === "md" ? "h-9 w-auto" : "h-7 w-auto";

  const lockupSrc = variant === "on-dark" ? logoLockupOnDark : logoLockupColor;

  return (
    <Link to="/" className={`flex items-center shrink-0 ${className}`} onClick={onClick}>
      {iconOnly ? (
        <img src={logoIcon} alt="BookMyCoaching" className={`${iconClass} max-w-full`} />
      ) : (
        <img src={lockupSrc} alt="BookMyCoaching" className={`${lockupClass} max-w-full`} />
      )}
    </Link>
  );
}
